module.exports = __webpack_public_path__ + "static/media/checkyesselected1.437355e5.png";